<template>
  <div >
    <b-card no-body>
      <b-table :items="reportLines" hover bordered :fields="fields" class="report-table" responsive sticky-header no-border-collapse>
        <template v-slot:head(name)="scope">
          <div class="text-nowrap">{{scope.label}}</div>
        </template>
      </b-table>
    </b-card>

  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapState, mapActions } from 'vuex'
  export default {
    name: 'OccupancyOverviewTable',
    props: {
      reportData: Object,
      type: String
    },
    data: () => {
      return {
        fields: [],
        reportLines: [],
      }
    },
    created() {
      let headers = [{key: 'name', label: this.reportData.type, thStyle: {"min-width": "120px"}, stickyColumn:true}]
      let total = this.reportData.headers.length

      _.each(this.reportData.headers, (header) => {
        headers.push(header.toString())
      })

      this.fields = headers

      let data =this.reportData.data
      for (var key in data) {
        let line = {}
        line.name = data[key].building.name

        for (var item in data[key][this.type]) {
          line[item] = data[key][this.type][item]
        }
        this.reportLines.push(line)
      }
    }
  }
</script>

<style lang="scss">
.report-table td {
  padding: 0.25rem;
}
</style>
